import React from "react";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import { EditIcon, DeleteIcon } from "api/icons/GlobalIcon";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import styles from "./ManageCard-jss";

const ManageCard = ({ name, description, handelDelete, renderDeleteAction, path, state, content, classes }) => (
  <Card className={classes.card}>
    <CardHeader
      className={classes.cardHeader}
      title={(
        <div className={classes.cardTitleWrap}>
          <p className={classes.cardTitle}>{name}</p>
          {description && <p className={classes.cardDescription}>{description}</p>}
        </div>
      )}
      action={(
        <div className={classes.cardActions}>
          <Link
            to={{
              pathname: path,
              state: { state },
            }}
          >
            <EditIcon />
          </Link>
          {renderDeleteAction ? renderDeleteAction() : (
            <button type="button" onClick={handelDelete}>
              <DeleteIcon />
            </button>
          )}
        </div>
      )}
    />
    <CardContent className={classes.cardContent}>
      {content}
    </CardContent>
  </Card>
);

export default withStyles(styles)(ManageCard);
